import * as yup from "yup";
import YupPassword from "yup-password";
import i18n from "../../i18n";
import containsConsecutives from "../../utils/containsConsecutives";

YupPassword(yup); // extend yup

yup.addMethod(yup.string, "containsConsecutives", function(errorMessage, len) {
    return this.test(`sequential-numbers-and-letters`, errorMessage, function(value) {
        const {path, createError} = this;
        return containsConsecutives(value, len) ? createError({path, message: errorMessage}) : true;
    });
});

const requiredMessage = () => i18n.t("validation.required", {ns: "common"});
const matchMessage = () => i18n.t("validation.passwordMatch", {ns: "common"});
const lengthMessage = () => i18n.t("validation.passwordLength", {ns: "common"});
const missingCharMessage = () => i18n.t("validation.passwordMissingChar", {ns: "common"});
const repeatMessage = () => i18n.t("validation.passwordSequentialChar", {ns: "common"});
const containsConsecutivesMessage = () => i18n.t("validation.passwordConsecutive", {ns: "common"});

export const newPasswordFormValidation = yup.object().shape({
    newPassword: yup
        .string()
        .minLowercase(1, missingCharMessage)
        .minUppercase(1, missingCharMessage)
        .minNumbers(1, missingCharMessage)
        .minRepeating(2, repeatMessage)
        .containsConsecutives(containsConsecutivesMessage, 3)
        .min(8, lengthMessage)
        .required(requiredMessage),
    passwordConfirm: yup
        .string()
        .oneOf([yup.ref("newPassword"), null], matchMessage)
        .required(requiredMessage)
});
